<template>
    <div class="right-box">
        <title1 title="实时告警" subTitle="Real-time Alarm" />
        <div class="flex justify-between mt-50">
            <div
                v-for="(item, i) in target1"
                :key="'target1' + i"
                class="flex align-center justify-center target3">
                <img v-if="item.number > 0" class="img" :src="item.iconAt" />
                <img v-else class="img" :src="item.icon" />
                <div class="flex flex-direction align-center">
                    <div class="label">{{ item.label}}</div>
                    <div class="text" :style="{'color': item.number > 0 ? '#FF4348' : ''}">{{ item.number }}</div>
                </div>
            </div>
        </div>

        <title1 class="mt-60" type="2" title="最新告警列表信息" />
        <div class="box-1 mt-30" style="height:340px">
		    <dv-scroll-board class="gaojinglist" :config="config" />
        </div>

        <title1 class="mt-60" title="告警分析" subTitle="Alarm Analysis" />
        <div class="flex mt-10 justify-between" style="height: 500px;">
            <div class="flex flex-direction" style="width: 49%">
                <title1 type="2" title="预警趋势" />
                <div class="mt-20" style="height: 350px">
                    <myEchart
                        v-if="yujingqushiShow"
                        :id="'yujingqushi'"
                        :options="yujingqushiOptions" />
                </div>
                <title1 class="mt-20" type="2" title="日告警趋势" />
                <div style="height: 350px">
                    <myEchart
                        v-if="gaojingqushiShow"
                        :id="'gaojingqushi'"
                        :options="gaojingqushiOptions" />
                </div>
            </div>
            <div class="" style="width: 49%">
                <dv-scroll-ranking-board class="gaojingfenxi" :config="config1" />
            </div>
        </div>
    </div>
</template>

<script>
import title1 from '@/views/exposition/components/title1'
import { formatTime } from '@/utils/index'
import { dataInterface } from '@/api/dataInterfaceApi'
import myEchart from './../charts/echarts'
import * as echarts from 'echarts5'
export default {
    components: {
        title1,
        myEchart
    },
    data() {
        return {
            target1: [
                {
                    icon: require('@/assets/images/exposition/chd-gj-1.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-1-at.png'),
                    number: '',
                    label: '消防系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-2.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-2-at.png'),
                    number: '',
                    label: '电池系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-3.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-3-at.png'),
                    number: '',
                    label: '换电系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-4.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-4-at.png'),
                    number: '',
                    label: '站控系统'
                },
                {
                    icon: require('@/assets/images/exposition/chd-gj-5.png'),
                    iconAt: require('@/assets/images/exposition/chd-gj-5-at.png'),
                    number: '',
                    label: '充电系统'
                },
            ],
			config: {
				headerBGC: "rgba(53, 149, 147, 0.2)",
				headerHeight: 50,
				carousel: "single",
				hoverPause: true,
				oddRowBGC: "rgba(53, 149, 147, 0)",
				evenRowBGC: "rgba(53, 149, 147, 0)",
				rowNum: 3, //表格行数
				header: ["告警时间", "城市", "站点", "设备编码", "告警类别", "告警内容"],
				data: [],
			},
            config1: {
				carousel: "single",
				rowNum: 5, //表格行数
				data: [],
			},
            yujingqushiShow: false,
            yujingqushiOptions: {},

            gaojingqushiShow: false,
            gaojingqushiOptions: {},
        }
    },
    methods: {
        getData(data) {
            // 实时告警
            this.gaojing(data)
            // 最新告警列表信息
            this.gaojingList(data)
            // 告警分析
            this.gaojingfenxi(data)
            // 预警趋势
            this.yujingqushi(data)
            // 日告警趋势
            this.gaojingqushi(data)
        },

        // 实时告警
        gaojing(data) {
            let province = data.province || data.city || data.district || ''
            let params = {
                "enCode": !province ? "TiDB-quanguo-shishigaojing" : 'TiDB-shengshiqu-shishigaojing',
            }
            province ? params['@province'] = province : ''
            dataInterface.dataFaceApi(params).then((res) => {
                console.log('=========', res)
                if(!res || !res.length) return
                // let alarmTimesNum = res[0] && res[0].alarmTimesNum || []
                res.map((item, i) => {
                    this.target1[i].number = item.alarmTimesNum
                })
            })
            .catch((err) => {
                console.log(err)
            })
        },

        // 最新告警列表信息
        gaojingList(data) {
            let province = data.province || data.city || data.district || ''
            let params = {
                "enCode": !province ? "TiDB-quanguo-zuixingaojingliebiaoxinxi" : 'TiDB-shengshiqu-zuixingaojingliebiaoxinxi',
            }
            province ? params['@province'] = province : ''
			dataInterface.dataFaceApi(params).then((res) => {
                if (!res || !res.length) return;
                console.log("最新告警列表", res)
                let newList = [];
                res.map(item => {
                    let arrlist = [
                        formatTime(item.time_occurrence, 'yyyy-MM-dd'),
                        item.cityName,
                        item.stationName,
                        item.alarmEquipmentCode,
                        item.alarm_classification,
                        item.alarm_name
                    ];
                    newList.push(arrlist)
                });
                this.config = {
                    headerBGC: "rgba(53, 149, 147, 0.2)",
                    headerHeight: 50,
                    carousel: "single",
                    hoverPause: true,
                    oddRowBGC: "rgba(53, 149, 147, 0)",
                    evenRowBGC: "rgba(53, 149, 147, 0)",
                    rowNum: 5, //表格行数
                    header: ["告警时间", "城市", "站点", "设备编码", "告警类别", "告警内容"],
                    data: newList,
                };
            })
            .catch((err) => {
                console.log(err);
            });
        },

        // 告警分析
        gaojingfenxi(data) {
            let province = data.province || data.city || data.district || ''
            let params = {
                "enCode": !province ? "TiDB-quanguo-chengshiyujingpaiming" : 'TiDB-shengshiqu-chengshiyujingpaiming',
            }
            province ? params['@province'] = province : ''
			dataInterface.dataFaceApi(params).then((res) => {
                if (!res || !res.length) return
                let dList = []
                res.map(item => {
                    dList.push({
                        name: item.cityName,
                        value: parseInt(item.alarmNum, 10)
                    })
                })
                this.config1 = {
                    carousel: "single",
                    rowNum: 6, //表格行数
                    waitTime: 3000000,
                    data: dList,
                }
            })
        },

        // 预警趋势
        yujingqushi(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-yujingshijianqushi' : 'TiDB-shengshiqu-yujingshijianqushi',
			}
            province ? params['@province'] = province : ''
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                // let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push(item.alarmNum)
                })
                this.yujingqushiShow = false
                this.yujingqushiOptions = {
                    title: {
                        text: '       个'
                    },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    color: ['#8bcfd0'],
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '告警数',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#8bcfd0'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(83, 250, 254, 0.60)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(83, 249, 253, 0)'
                                }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 个';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData1
                        },
                    ]
                }
                this.yujingqushiShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},

        // 日告警趋势
        gaojingqushi(data = {}) {
			let params = {}
            let province = data.province || data.city || data.district || ''
			params = {
				'enCode': !province ? 'TiDB-quanguo-rigaojingshuliang' : 'TiDB-shengshiqu-rigaojingshuliang',
            }
            province ? params['@province'] = province : ''
			dataInterface.dataFaceApi(params).then((res) => {
				if (!res || !res.length) return
				// let data = res && res[0] || {}
                let xData = []
                let yData1 = []
                let yData2 = []
                res.map(item => {
                    xData.push(item.cur_date)
                    yData1.push(item.last_alarmNum)
                    yData2.push(item.cur_alarmNum)
                })
                this.gaojingqushiShow = false
                this.gaojingqushiOptions = {
                    title: {
                        text: '       个'
                    },
                    color: ['#4fc1ef', '#8bcfd0'],
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: {
                            type: 'shadow'
                        }
                    },
                    xAxis: {
                        type: 'category',
                        data: xData
                    },
                    yAxis: {
                        type: 'value'
                    },
                    series: [
                        {
                            name: '上月',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#4fc1ef'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(79, 193, 239, 1)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(77, 194, 241, 0)'
                                }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 个';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData1
                        },
                        {
                            name: '本月',
                            type: 'line',
                            smooth: true,
                            lineStyle: {
                                width: 0
                            },
                            showSymbol: false,
                            label: {
                                show: true,
                                position: 'top'
                            },
                            lineStyle: {
                                width: 2,
                                color: '#8bcfd0'
                            },
                            areaStyle: {
                                opacity: 0.8,
                                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                                {
                                    offset: 0,
                                    color: 'rgba(139, 207, 208, 1)'
                                },
                                {
                                    offset: 1,
                                    color: 'rgba(134, 201, 203, 0)'
                                }
                                ])
                            },
                            tooltip: {
                                valueFormatter: function (value) {
                                    return value + ' 个';
                                }
                            },
                            emphasis: {
                                focus: 'series'
                            },
                            data: yData2
                        },
                    ]
                }
                this.gaojingqushiShow = true
			})
			.catch((err) => {
				console.log(err)
			})
		},

    }
}
</script>

<style lang="scss" scoped>
@import '../scss/chd-com.scss';
</style>
<style lang="scss">
    .gaojingfenxi {
        &.dv-scroll-ranking-board {
            .ranking-info {
                font-size: 20px;
                .rank {
                    color: #1FC9C9;
                    width: 80px;
                }
            }
            .ranking-column {
                border: none;
                .inside-column {
                    background: linear-gradient(180deg, #9BFFFC 0%, #65FFF9 25%, rgba(155,255,252,0.2) 100%) !important;
                }
            }
        }
    }
    .gaojinglist {
        &.dv-scroll-board {
            .header, .rows .row-item {
                font-size: 20px;
            }
            
        }
    }
</style>
